export default {"src":"/_next/static/media/relaxing.dc0b595e.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};